type ToastSeverity = "success" | "error" | "info" | "warning";

interface ToastEvent {
  message: string;
  severity: ToastSeverity;
}

type ToastListener = (event: ToastEvent) => void;

class ToastEmitter {
  private listeners: ToastListener[] = [];

  subscribe(listener: ToastListener) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener);
    };
  }

  emit(message: string, severity: ToastSeverity = "error") {
    for (const listener of this.listeners) {
      listener({ message, severity });
    }
  }
}

export const toastEmitter = new ToastEmitter();
